import { Global, Lock } from 'iconsax-react';
import { ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@src/design-system/dropdown-menu';
import { cn } from '@src/design-system/helpers';

export function PublicOrPrivateDropdown({
  onChange,
  value,
  variant = 'default',
}: {
  value: boolean;
  onChange: (val: boolean) => void;
  /** `toolbar` matches the Edit View dialog header (Figma). */
  variant?: 'default' | 'toolbar';
}) {
  const options = [
    {
      label: 'Private',
      value: false,
      icon: (
        <Lock
          variant='Bold'
          size={16}
        />
      ),
      className: 'text-gray-900 bg-primary-50 hover:bg-primary-50',
      toolbarClassName: 'text-gray-800 border-primary-200',
    },
    {
      label: 'Public',
      value: true,
      icon: <Global size={16} />,
      className: 'text-blue-600 bg-blue-50 hover:bg-blue-50',
      toolbarClassName: 'text-gray-800 border-primary-200',
    },
  ];

  const currentValue = options.find((opt) => opt.value === value);
  const isToolbar = variant === 'toolbar';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          'inline-flex cursor-pointer items-center justify-center gap-2 rounded-xl text-sm leading-none [&_svg]:shrink-0',
          isToolbar
            ? cn(
                'h-10 shrink-0 gap-1 border border-solid bg-transparent px-3 py-0 text-[11px] hover:bg-primary-50',
                currentValue?.toolbarClassName
              )
            : cn(
                'bg-primary-50 p-2 text-gray-900 hover:bg-primary-100/60',
                currentValue?.className
              )
        )}
      >
        {currentValue?.icon}
        <span className='leading-none'>{currentValue?.label}</span>
        <ChevronDown size={16} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align='start'>
        {options.map((opt) => (
          <DropdownMenuItem
            className={cn(opt.label === currentValue?.label && opt.className)}
            onClick={() => onChange(opt.value)}
            key={opt.value.toString()}
          >
            {opt.icon} {opt.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
